import { render, staticRenderFns } from "./AutodiscoveryWidget.vue?vue&type=template&id=00457de5&scoped=true"
import script from "./AutodiscoveryWidget.vue?vue&type=script&lang=js"
export * from "./AutodiscoveryWidget.vue?vue&type=script&lang=js"
import style0 from "./AutodiscoveryWidget.vue?vue&type=style&index=0&id=00457de5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00457de5",
  null
  
)

export default component.exports